import { Box, LinearProgress, Typography, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React from 'react'

interface ProgressIndicatorProps {
  value: number
  height?: number
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  value,
  height = 0.17,
}) => {
  const theme = useTheme()

  return (
    <>
      <LinearProgress
        sx={{
          height,
          borderRadius: 0.5,
          width: '100%',
          background: alpha(theme.palette.common.white, 0.3),
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.common.white,
          },
        }}
        variant="determinate"
        value={Math.min(100, Math.max(0, value))} // Ensure value is between 0 and 100
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          fontWeight={500}
          sx={{
            color: theme.palette.common.black,
            fontSize: '0.9375rem',
          }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </>
  )
}

export default ProgressIndicator
